const l = [
  "beacon-area-chart",
  "beacon-article-tile",
  "beacon-bar-chart",
  "beacon-bio-card",
  "beacon-button",
  "beacon-byline",
  "beacon-carousel",
  "beacon-chart-tooltip",
  "beacon-chart-tooltip-data",
  "beacon-checkbox",
  "beacon-collection-tile",
  "beacon-contact-tile",
  "beacon-country",
  "beacon-country-selector",
  "beacon-data-list",
  "beacon-date-picker",
  "beacon-donut-chart",
  "beacon-dropdown",
  "beacon-error",
  "beacon-error-message-summary",
  "beacon-footer",
  "beacon-gauge-chart",
  "beacon-hero",
  "beacon-icon-button",
  "beacon-id-card",
  "beacon-input-button-field",
  "beacon-input-field",
  "beacon-key-facts",
  "beacon-legacy-collection-tile",
  "beacon-legend",
  "beacon-legend-item",
  "beacon-line-chart",
  "beacon-modal",
  "beacon-navigation",
  "beacon-navigation-button",
  "beacon-navigation-expanded",
  "beacon-navigation-footer",
  "beacon-navigation-popover",
  "beacon-navigation-toolbelt",
  "beacon-popover",
  "beacon-promo-tile",
  "beacon-quote-block",
  "beacon-radio-button",
  "beacon-radio-group",
  "beacon-region-selector",
  "beacon-scatter-chart",
  "beacon-social-link",
  "beacon-social-link-container",
  "beacon-stepper",
  "beacon-tab",
  "beacon-tab-panel",
  "beacon-table",
  "beacon-table-caption",
  "beacon-table-header",
  "beacon-table-record",
  "beacon-table-stub",
  "beacon-tabs",
  "beacon-text-area",
  "beacon-toggle-button-field",
  "beacon-tooltip",
  "beacon-value-prop",
  "beacon-video",
  "beacon-video-tag",
  "beacon-video-transcript"
], x = {
  allComponents: l
}, j = (t) => t.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (e, a) => (a ? "-" : "") + e.toLowerCase()), g = (t) => /^([a-z](?![\d])|[\d](?![a-z]))+(-?([a-z](?![\d])|[\d](?![a-z])))*$|^$/.test(t);
function h(t) {
  return `${t}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(new RegExp(/\s+(.)(\w*)/, "g"), (e, a, n) => `${a.toUpperCase() + n}`).replace(new RegExp(/\w/), (e) => e.toUpperCase());
}
const v = typeof process == "object" && process && process.env && process.env.UNIT_TESTING_ENV;
function f(t) {
  switch (t) {
    case "./__temp-separated/beacon-area-chart/index.js":
      return import("./register-chunks/index-B0syMEtV.js");
    case "./__temp-separated/beacon-article-tile/index.js":
      return import("./register-chunks/index-CWlFprjU.js");
    case "./__temp-separated/beacon-bar-chart/index.js":
      return import("./register-chunks/index-NT5ONS4l.js");
    case "./__temp-separated/beacon-bio-card/index.js":
      return import("./register-chunks/index-BzCkjqN3.js");
    case "./__temp-separated/beacon-button/index.js":
      return import("./register-chunks/index-DqRaVDNO.js");
    case "./__temp-separated/beacon-byline/index.js":
      return import("./register-chunks/index-C8zZdaTz.js");
    case "./__temp-separated/beacon-carousel/index.js":
      return import("./register-chunks/index-0y0_CZDv.js");
    case "./__temp-separated/beacon-chart-tooltip/index.js":
      return import("./register-chunks/index--wFQl61r.js");
    case "./__temp-separated/beacon-chart-tooltip-data/index.js":
      return import("./register-chunks/index-B6LSqYb9.js");
    case "./__temp-separated/beacon-checkbox/index.js":
      return import("./register-chunks/index-DMqw4UJc.js");
    case "./__temp-separated/beacon-collection-tile/index.js":
      return import("./register-chunks/index-gNRH1Yu1.js");
    case "./__temp-separated/beacon-contact-tile/index.js":
      return import("./register-chunks/index-DM3vUx0F.js");
    case "./__temp-separated/beacon-country/index.js":
      return import("./register-chunks/index-DpDC-psa.js");
    case "./__temp-separated/beacon-country-selector/index.js":
      return import("./register-chunks/index-8eVrs-5m.js");
    case "./__temp-separated/beacon-data-list/index.js":
      return import("./register-chunks/index-CM3U19ML.js");
    case "./__temp-separated/beacon-date-picker/index.js":
      return import("./register-chunks/index-TNWy8ILd.js");
    case "./__temp-separated/beacon-donut-chart/index.js":
      return import("./register-chunks/index-DomexrJB.js");
    case "./__temp-separated/beacon-dropdown/index.js":
      return import("./register-chunks/index-DCKvYxeA.js");
    case "./__temp-separated/beacon-error/index.js":
      return import("./register-chunks/index-ejgp6MSj.js");
    case "./__temp-separated/beacon-error-message-summary/index.js":
      return import("./register-chunks/index-C-V5U-D2.js");
    case "./__temp-separated/beacon-footer/index.js":
      return import("./register-chunks/index-BlbgVEtL.js");
    case "./__temp-separated/beacon-gauge-chart/index.js":
      return import("./register-chunks/index-DS71QnRe.js");
    case "./__temp-separated/beacon-hero/index.js":
      return import("./register-chunks/index-C1kOB87I.js");
    case "./__temp-separated/beacon-icon-button/index.js":
      return import("./register-chunks/index-BNxmm9DU.js");
    case "./__temp-separated/beacon-id-card/index.js":
      return import("./register-chunks/index-CN1zFi_K.js");
    case "./__temp-separated/beacon-input-button-field/index.js":
      return import("./register-chunks/index-DdsxMNsO.js");
    case "./__temp-separated/beacon-input-field/index.js":
      return import("./register-chunks/index-BrNdfeeY.js");
    case "./__temp-separated/beacon-key-facts/index.js":
      return import("./register-chunks/index-cikCx70F.js");
    case "./__temp-separated/beacon-legacy-collection-tile/index.js":
      return import("./register-chunks/index-kR1PEZlA.js");
    case "./__temp-separated/beacon-legend/index.js":
      return import("./register-chunks/index-D7ZGcgUG.js");
    case "./__temp-separated/beacon-legend-item/index.js":
      return import("./register-chunks/index-Cgvu8aIu.js");
    case "./__temp-separated/beacon-line-chart/index.js":
      return import("./register-chunks/index-Bu7_EMdG.js");
    case "./__temp-separated/beacon-modal/index.js":
      return import("./register-chunks/index-DduDrga2.js").then((e) => e.index);
    case "./__temp-separated/beacon-navigation/index.js":
      return import("./register-chunks/index-DBmLzGCz.js").then((e) => e.index);
    case "./__temp-separated/beacon-navigation-button/index.js":
      return import("./register-chunks/index-DBmLzGCz.js").then((e) => e.index$1);
    case "./__temp-separated/beacon-navigation-expanded/index.js":
      return import("./register-chunks/index-DBmLzGCz.js").then((e) => e.index$2);
    case "./__temp-separated/beacon-navigation-footer/index.js":
      return import("./register-chunks/index-Ddc70-zX.js");
    case "./__temp-separated/beacon-navigation-popover/index.js":
      return import("./register-chunks/index-DBmLzGCz.js").then((e) => e.index$3);
    case "./__temp-separated/beacon-navigation-toolbelt/index.js":
      return import("./register-chunks/index-DBmLzGCz.js").then((e) => e.index$4);
    case "./__temp-separated/beacon-popover/index.js":
      return import("./register-chunks/index-pej284Hj.js");
    case "./__temp-separated/beacon-promo-tile/index.js":
      return import("./register-chunks/index-CBXF0gr0.js");
    case "./__temp-separated/beacon-quote-block/index.js":
      return import("./register-chunks/index-BY8dY_Zn.js");
    case "./__temp-separated/beacon-radio-button/index.js":
      return import("./register-chunks/index-Dc6Via1G.js");
    case "./__temp-separated/beacon-radio-group/index.js":
      return import("./register-chunks/index-C8xH-G_A.js");
    case "./__temp-separated/beacon-region-selector/index.js":
      return import("./register-chunks/index-BzbsVDCE.js");
    case "./__temp-separated/beacon-scatter-chart/index.js":
      return import("./register-chunks/index-Cjs1ABeW.js");
    case "./__temp-separated/beacon-social-link/index.js":
      return import("./register-chunks/index-BhyyeCKG.js");
    case "./__temp-separated/beacon-social-link-container/index.js":
      return import("./register-chunks/index-CniRfggc.js");
    case "./__temp-separated/beacon-stepper/index.js":
      return import("./register-chunks/index-DkZ28Yon.js");
    case "./__temp-separated/beacon-tab/index.js":
      return import("./register-chunks/index-D6QZDkLr.js");
    case "./__temp-separated/beacon-tab-panel/index.js":
      return import("./register-chunks/index-CtTcltHg.js");
    case "./__temp-separated/beacon-table/index.js":
      return import("./register-chunks/index-XxAo9r_b.js");
    case "./__temp-separated/beacon-table-caption/index.js":
      return import("./register-chunks/index-Cmt4LFop.js");
    case "./__temp-separated/beacon-table-header/index.js":
      return import("./register-chunks/index-B0kXPPls.js").then((e) => e.index);
    case "./__temp-separated/beacon-table-record/index.js":
      return import("./register-chunks/index-wySYn0sw.js").then((e) => e.index);
    case "./__temp-separated/beacon-table-stub/index.js":
      return import("./register-chunks/index-BDNhgi5O.js").then((e) => e.index);
    case "./__temp-separated/beacon-tabs/index.js":
      return import("./register-chunks/index-Ck81Jd6u.js");
    case "./__temp-separated/beacon-text-area/index.js":
      return import("./register-chunks/index-DiTVhJ9S.js");
    case "./__temp-separated/beacon-toggle-button-field/index.js":
      return import("./register-chunks/index-Bzj4YMMl.js");
    case "./__temp-separated/beacon-tooltip/index.js":
      return import("./register-chunks/index-yRJvpQpW.js");
    case "./__temp-separated/beacon-value-prop/index.js":
      return import("./register-chunks/index-CH9WDolo.js");
    case "./__temp-separated/beacon-video/index.js":
      return import("./register-chunks/index-SXnDytFB.js");
    case "./__temp-separated/beacon-video-tag/index.js":
      return import("./register-chunks/index-4ba5zzag.js");
    case "./__temp-separated/beacon-video-transcript/index.js":
      return import("./register-chunks/index-DQqqSNT8.js");
    default:
      return new Promise(function(e, a) {
        (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
          a.bind(null, new Error("Unknown variable dynamic import: " + t))
        );
      });
  }
}
const b = async (t = "", e = document.body) => {
  const a = t ? t + "-beacon-" : "beacon-", n = e instanceof Element ? e.tagName.toLowerCase() : "", c = n == null ? void 0 : n.startsWith(a), s = [...e.querySelectorAll(":not(:defined)")].map((r) => r.tagName.toLowerCase()).filter((r) => r.startsWith(a));
  c && !customElements.get(n) && s.push(n);
  const o = [...new Set(s)].map((r) => t ? r.split(`${t}-`)[1] : r);
  o.length && await C(t, o);
}, w = (t) => {
  const e = j(t);
  return g(t) || console.warn(
    `Beacon Warning: '${t}' is not a valid Beacon component tag name. Class name casing will be deprecated soon. Update to tag name "${e}".`
  ), e;
}, y = (t) => {
  const e = w(t);
  return {
    tagName: e,
    className: h(e)
  };
}, p = async (t, e, a) => new Promise((n, c) => {
  var s;
  if (typeof e == "string") {
    const { tagName: o, className: r } = y(e), d = t ? `${t}-${o}` : o;
    customElements.get(d) ? n(customElements.get(d)) : f(`./__temp-separated/${o}/index.js`).then((_) => {
      var m;
      const i = _[`${r}`];
      i.registerComponent(t), (m = i.nestedComponents) != null && m.length && Promise.all(
        i.nestedComponents.map(
          (u) => p(t, u, a)
        )
      ), n(i);
    }).catch(() => {
      a && c(new Error(`Beacon Registration Error: Unable to import ${e}`));
    });
  } else if (e.registerComponent) {
    const o = e;
    o.registerComponent(t), (s = o.nestedComponents) != null && s.length && Promise.all(
      o.nestedComponents.map(
        (r) => p(t, r, a)
      )
    ), n(o);
  }
}), C = async (t = "", e = [], a = !v) => {
  const n = e.length ? e : x.allComponents;
  await Promise.all(
    n.map(
      (c) => p(t, c, a)
    )
  );
}, k = async (t = "") => {
  const e = new MutationObserver(async (a) => {
    for (const { addedNodes: n } of a)
      for (const c of n)
        c.nodeType === Node.ELEMENT_NODE && await b(t, c);
  });
  return await b(t), e.observe(document.documentElement, { subtree: !0, childList: !0 }), e;
};
export {
  k as autoLoadBeaconComponents,
  y as getComponentIdentifiers,
  w as getComponentTagName,
  p as importAndRegisterComponent,
  C as registerBeaconComponents
};
